import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Highcharts from "highcharts";
    import { Chart } from "highcharts-vue";
    import "highcharts/modules/accessibility";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MobileIncomeChart',
  props: {
        data: { type: Array<number>, default: [] }
    },
  emits: {
        'yearSelected': null
    },
  setup(__props, { emit: __emit }) {


    const props = __props;

    const emit = __emit;

    const chartOptions = {
        accessibility: {
            enabled: true,
            description: 'An income plan chart displaying the distribution of funds across up to 34 years of retirement.',
            keyboardNavigation: {
                enabled: true,
            },
            announceNewData: {
                enabled: true,
                minAnnounceInterval: 2000
            },
            pointDescriptionFormatter: function (point) {
                return `Year ${point.category}, value ${point.y} thousand pounds.`;
            }
        },
        chart: {
            type: 'column',
            spacingLeft: 0,
            marginRight: 0,
            animation: {
                duration: 1100
            }
        },
        title: {
            text: 'Retirement Year Distribution'
        },
        xAxis: {
            title: {
                text: 'Retirement Year'
            },
            crosshair: true,
            accessibility: {
                description: 'Each year of retirement (up to 34).'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Cash amount (in thousands)'
            },
            accessibility: {
                description: 'Cash amount (in thousands) allocated to each year.'
            }
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
            series: {
                cursor: 'pointer',
                events: {
                    click: function(event) {
                        emit('yearSelected', event.point.category - 1);
                    }
                },
                color: 'rgb(40, 121, 188)',
                accessibility: {
                    enabled: true,
                    description: 'Interactive bars for configuring the amount of money allocated to each year of retirement.'
                }
            }
        },
        series: [
            {
                name: 'Pension distribution',
                pointStart: 1,
                data: props.data,
                showInLegend: false,
                selected: 4,
                accessibility: {
                    exposeAsGroupOnly: false,
                    description: 'The dataset represents the distribution of funds across up to 34 years of retirement.'
                }
            }
        ]
    };


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Highcharts), { options: chartOptions }))
}
}

})